<template>
    <div class="card mt-3">
        <div class="card-body text-center" v-if="partidos.length == 0">
            No hay partidos programados.
        </div>
        <div class="card-body">
            <Partido
                :partido="partido"
                v-for="partido in partidos"
                :key="partido.partidoid"
                :live="live"
            />
        </div>
        <div class="card-footer">
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="live"
                    id="liveCheck"
                />
                <label class="form-check-label" for="liveCheck"> Live </label>
            </div>
        </div>
    </div>
</template>

<script>
import Partido from "../components/Partido.vue";
export default {
    props: ["partidos"],
    data() {
        return {
            live: true,
        };
    },
    components: {
        Partido,
    },
};
</script>
